module.exports = __webpack_public_path__ + "img/plane.3f3ae9ae.jpg";